import { useEffect, useState } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import About from './pages/About'
import Stores from './pages/Stores'
import Services from './pages/Services'
import Contact from './pages/Contact'
import AnalyticsService from './services/AnalyticsService'

import constructorService from './services/ConstructorService'

// import PageRenderer from './components/PageRenderer'
import MainLayout from './components/MainLayout'
import Loading from './components/Loading'

function App() {
  const routes = [
    {
      path: '/',
      component: <Home />
    },
    {
      path: '/sobre',
      component: <About />
    },
    {
      path: '/servicos',
      component: <Services />
    },
    {
      path: '/lojas',
      component: <Stores />
    },
    {
      path: '/contato',
      component: <Contact />
    }
  ]

  const [website, setWebsite] = useState(undefined)

  useEffect(() => {
    AnalyticsService.initialize();
    
    const fetchData = async () => {
      try {
        const website = null // await constructorService.fetchWebsiteFromApi()
        setWebsite(website)
      } catch (error) {
        console.error('Erro ao fazer conexão com a API:', error.message)

        try {
          const website = constructorService.fetchWebsiteFromCache()
          if (!website) {
            throw new Error('Nenhum cache encontrado')
          }

          console.warn('Usando dados do cache para construção do site')
          setWebsite(website)
        } catch (error) {
          console.error('Erro ao carregar o site: ', error.message)
          setWebsite({ error: true })
        }
      }
    }
    fetchData()
  }, [])

  if (website === undefined) {
    return <Loading />
  }

  return (
    <Router>
      <Routes>
        <Route element={<MainLayout />}>
          {routes.map((route) => (
            <Route key={route.path} path={route.path} element={route.component} />
          ))}
        </Route>
      </Routes>
    </Router>
  )
}

export default App
